import { Outlet } from "react-router-dom";
import * as styled from "./Admin.styled.jsx";
import LeftPanel from "../../../components/LeftPanel/LeftPanel.jsx";
import { MainContent } from "../../../styles/components/MainContent.styled.jsx";
import { langs } from "../../../helpers/langs";
import { canSwitchAdminLang, switchAdminLang } from "../../../helpers/adminLang";

// school — інструменти на всю школу без поділу на мови: лише в кабінетах "en" і "all", у кабінеті іспанської їх немає
const navList = [
  { name: 'Головна', link: "general"},
  { name: "Воронка", link: "funnel", school: true },
  { name: "Контент", link: "content", school: true },
  { name: "Розсилки", link: "bot", school: true },
  { name: "Ризик відтоку", link: "churn-risk", school: true },
  { name: "Контроль вчителів", link: "teachers-control", school: true },
  { name: "Наші учні", link: "ourstudents" },
  { name: "Наші вчителі", link: "ourteachers" },
  { name: "Наші менеджери", link: "ourmanagers" },
  { name: "Виплата вчителям", link: "teacher-salary" },
  { name: "Бонуси вчителям", link: "teacher-bonuses", school: true },
  { name: "Оплата учнів", link: "lesson-payment" },
  { name: "Пробні уроки", link: "trial-lessons" },
  { name: "Відмітки про урок", link: "teachers-mark" },
  { name: "Матеріали", link: "materials" }, 
  { name: "Магазин зірок", link: "shop", school: true },
  // { name: "Зміни уроку", link: "lesson-reschedule" }, 
];
function Admin({adminInfo}) {
  return (
    <styled.Wrapper>
      <LeftPanel
        pageTitle={`Admin‘s Room ${adminInfo.accessType}`}
        navList={adminInfo.accessType === "all"
          ? navList.filter(({link}) => link !== 'teacher-salary' && link !== 'lesson-reschedule' && link !== 'materials')
          : navList.filter(({school}) => !school || adminInfo.accessType === "en")}
        currentRoute={"/admin"}
      />

      <MainContent>
        {canSwitchAdminLang(adminInfo) && (
          <styled.LangBar>
            {langs.map(({ key, value }) => (
              <styled.LangBtn key={key} $active={adminInfo.accessType === key} onClick={() => adminInfo.accessType !== key && switchAdminLang(adminInfo, key)}>
                {value}
              </styled.LangBtn>
            ))}
          </styled.LangBar>
        )}
        <Outlet />
      </MainContent>
    </styled.Wrapper>
  );
}

export default Admin;
